import {
  selectNavigationStyleIsLoading,
  selectNavigationStyleIsSubmitting,
} from 'api/navigationStyle'
import {
  selectNavigationTabsIsLoading,
  selectNavigationTabsIsSubmitting,
} from 'api/navigationTabs'
import { buildTranslate } from 'locales'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PublishBanner from 'scenes/Cms/components/PublishBanner'
import { showConfirmModal } from 'slices/Cms/Content/AppNavigation'
import { selectBottomNavHasChanges } from 'slices/Cms/Content/AppNavigation/BottomNav/selectors'
import { selectStyleHasChanges } from 'slices/Cms/Content/AppNavigation/Style/selectors'

const t = buildTranslate('cms.content.app_navigation')

const Footer: React.FC = () => {
  const dispatch = useDispatch()

  // Get loading states using clean selectors (no parameters needed!)
  const isStyleLoading = useSelector(selectNavigationStyleIsLoading)
  const isTabsLoading = useSelector(selectNavigationTabsIsLoading)
  const isStyleSubmitting = useSelector(selectNavigationStyleIsSubmitting)
  const isTabsSubmitting = useSelector(selectNavigationTabsIsSubmitting)

  // Combine loading states
  const isLoading = isStyleLoading || isTabsLoading
  const isFormSubmitting = isStyleSubmitting || isTabsSubmitting

  const hasChanges = useSelector(selectStyleHasChanges)
  const bottomNavHasChanges = useSelector(selectBottomNavHasChanges)

  const confirmSubmit = () => {
    dispatch(showConfirmModal())
  }

  return (
    <PublishBanner
      buttonText={t('footer.publish')}
      isLoading={isLoading || isFormSubmitting}
      disabled={!hasChanges && !bottomNavHasChanges}
      buttonType="button"
      onClick={confirmSubmit}
    />
  )
}

export default Footer
